import { render, staticRenderFns } from "./JournalInfo.vue?vue&type=template&id=971645c4"
import script from "./JournalInfo.vue?vue&type=script&lang=js"
export * from "./JournalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971645c4')) {
      api.createRecord('971645c4', component.options)
    } else {
      api.reload('971645c4', component.options)
    }
    module.hot.accept("./JournalInfo.vue?vue&type=template&id=971645c4", function () {
      api.rerender('971645c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/JournalInfo.vue"
export default component.exports